module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.6@core-js/library/modules/_redefine.js
// module id = 43
// module chunks = 0